import {
  GET_CORPORATE_DATA,
  GET_CORPORATE_DATA_SUCCESS,
  GET_CORPORATE_DATA_FAILURE,
} from "../actionTypes";

export const getCorporateData = (payload) => ({
  type: GET_CORPORATE_DATA,
  payload,
});

export const getCorporateDataSuccess = (payload) => ({
  type: GET_CORPORATE_DATA_SUCCESS,
  payload,
});

export const getCorporateDataFailure = () => ({
  type: GET_CORPORATE_DATA_FAILURE,
});